module.exports = __webpack_public_path__ + "img/cbd6blur.73bbaec9.jpg";